<template>
  <div v-loading="loading" class="v-container">
    <div class="v-page-header">基础信息管理</div>
    <div class="v-content">
      <el-form ref="vForm" label-width="110px" auto-complete="off" size="medium" class="form" :model="vForm">
        <el-form-item label="网站首页" class="form-group">
          <el-button type="text" @click="toIndex">{{ indexUrl }}</el-button>
        </el-form-item>
        <el-form-item label="网站名称" class="form-group" prop="title" :rules="{ required: true, message: '网站名称必填' }">
          <el-input v-model="vForm.title" type="text" class="form-control" />
          <div class="v-form-tips v-color-blue">显示浏览器Tab标签卡</div>
        </el-form-item>
        <el-form-item label="公司名称" class="form-group" prop="company" :rules="{ required: true, message: '公司名称必填' }">
          <el-input v-model="vForm.company" type="text" class="form-control" @change="$refs.vForm.validateField('company')" />
          <div class="v-form-tips v-color-blue">显示在手机端加载页底部</div>
        </el-form-item>
        <el-form-item label="网站ICO" class="form-group" prop="ico" >
          <v-upload-image v-model="vForm.ico" type="key" @change="$refs.vForm.validateField('ico')" />
          <div class="v-form-tips v-color-blue">显示在浏览器Tab标签卡</div>
          <div class="v-form-tips">尺寸100*100px，.ico文件</div>
        </el-form-item>
        <el-form-item label="PCLogo" class="form-group" prop="logo" >
          <v-upload-image v-model="vForm.logo" type="key" @change="$refs.vForm.validateField('logo')" />
          <div class="v-form-tips v-color-blue">显示电脑端首页</div>
          <div class="v-form-tips">尺寸高度40px，宽度不限</div>
        </el-form-item>
        <el-form-item label="PCLogo高度" class="form-group" >
          <el-input v-model="vForm.logoHeight" type="text" class="form-control">
            <div slot="append">px</div>
          </el-input>
          <div class="v-form-tips v-color-blue">显示电脑端首页LOGO高度</div>
        </el-form-item>
        <el-form-item label="手机端Logo" class="form-group" prop="mLogo">
          <v-upload-image v-model="vForm.mLogo" type="key" @change="$refs.vForm.validateField('mLogo')" />
          <div class="v-form-tips v-color-blue">显示在手机端加载页底部</div>
          <div class="v-form-tips">尺寸300*300px以内</div>
        </el-form-item>
        <el-form-item label="手机端Logo缩放比例" class="form-group" prop="mLogo" >
          <el-input v-model="vForm.mLogoScale" type="text" class="form-control">
            <div slot="append">倍</div>
          </el-input>
          <div class="v-form-tips">&gt;1为放大，&lt;1为缩小</div>
        </el-form-item>
        <el-form-item label="Banner" class="form-group" prop="banner" >
          <v-upload-image v-model="vForm.banner" type="key"/>
          <div class="v-form-tips v-color-blue">显示电脑端首页</div>
          <div class="v-form-tips">尺寸1920*80px</div>
        </el-form-item>
        <el-form-item label="手机端背景" class="form-group" prop="mBg" :rules="{ required: true, message: '手机端背景必填' }">
          <v-upload-image v-model="vForm.mBg" type="key" @change="$refs.vForm.validateField('mBg')" />
          <div class="v-form-tips v-color-blue">显示在手机端初始化加载页面</div>
          <div class="v-form-tips">尺寸750*1300px</div>
        </el-form-item>
        <el-form-item label="手机端开屏" class="form-group">
          <el-switch v-model="vForm.isBgOnly" active-text="仅显示图片" inactive-text="默认"></el-switch>
          <div class="v-form-tips v-color-red">开启后手机端首屏仅显示背景图片不显示其他内容</div>
        </el-form-item>
        <el-form-item label="手机端开屏" class="form-group">
          <el-switch v-model="vForm.isTouchOpen" active-text="点击进入地图" inactive-text="自动进入地图"></el-switch>
          <div class="v-form-tips v-color-red">开启后点击屏幕任意位置进入地图</div>
        </el-form-item>
        <el-form-item label="区域筛选功能" class="form-group">
          <el-switch v-model="vForm.isArea" active-text="开启" inactive-text="关闭"></el-switch>
        </el-form-item>
        <el-form-item label="首页详情介绍" class="form-group">
          <el-input v-model="vForm.desc" type="textarea" rows="4" placeholder="选填"></el-input>
        </el-form-item>
        <el-form-item label="地图图标文字（PC）" class="form-group">
          <el-slider v-model="vForm.zoom" :min="3" :max="18" show-input></el-slider>
          <div class="slider-box">
            <div class="slider-box-label">&lt;&lt;世界地图（隐藏标题）</div>
            <div class="slider-box-label">街道地图（显示标题）&gt;&gt;</div>
          </div>
          <div class="v-form-tips">级别越高越接近街道视野，大于指定级别时显示点位标题，小于时隐藏点位标题</div>
        </el-form-item>
        <el-form-item label="地图图标文字（手机）" class="form-group">
          <el-slider v-model="vForm.zoomMobile" :min="3" :max="18" show-input></el-slider>
          <div class="slider-box">
            <div class="slider-box-label">&lt;&lt;世界地图（隐藏标题）</div>
            <div class="slider-box-label">街道地图（显示标题）&gt;&gt;</div>
          </div>
          <div class="v-form-tips">级别越高越接近街道视野，大于指定级别时显示点位标题，小于时隐藏点位标题</div>
        </el-form-item>
        <el-form-item label="地图初始缩放">
          <el-input v-model="vForm.mInitZoom"
                    size="small"
                    class="range-value-input"
                    style="width: 150px;margin-right:5px"></el-input>
          <div class="v-form-tips">不填写默认根据覆盖物缩放，如果填写手机端启用指定缩放层级，取值3至18</div>
        </el-form-item>
        <el-form-item label="地图图标缩放">
          <div class="range-value-box">
            <div v-for="(item,index) in vForm.zoomRange"
                 :key="index"
                 class="range-value-item">
              <el-input size="small"
                        class="range-value-input"
                        v-model="item.min"
                        :disabled="index === 0"
                        style="width:200px">
                <template slot="prepend">地图级别区间：</template>
              </el-input>
              <div style="margin:0 5px">-</div>
              <el-input size="small"
                        lass="range-value-input"
                        v-model="item.max"
                        :disabled="index === vForm.zoomRange.length-1"
                        style="width: 100px;margin-right:30px">
              </el-input>
              <el-input size="small"
                        class="range-value-input"
                        v-model="item.scaleIcon"
                        style="width: 150px;margin-right:5px">
                <template slot="prepend">图标缩放：</template>
              </el-input>
              <el-input size="small"
                        class="range-value-input"
                        v-model="item.scaleText"
                        style="width: 150px">
                <template slot="prepend">文字缩放：</template>
              </el-input>
              <el-button class="v-ml-5" size="small" type="danger" :disabled="index === 0" @click="deleteRange(item,index)">删除</el-button>
            </div>
          </div>
          <el-button icon="el-icon-plus" class="v-mt-10" size="small" @click="addRange">新增区间</el-button>
          <div class="v-form-tips">地图缩放倍数取值3至18，3代表世界地图，18代表街道地图</div>
          <div class="v-form-tips">图标缩放与文字缩放取值应为0至1之间</div>
        </el-form-item>
        <el-form-item label="" class="form-group">
          <el-button type="primary" :loading="doSubmitLoading" size="small" @click="doSubmit">确认保存</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
	import configPage from '@/assets/js/configPage';

	export default {

		data() {
			return {
				loading: false,
				doSubmitLoading: false,
				vForm: {
					title: '',
					ico: '',
					logo: '',
					banner: '',
					mLogo: '',
					company: '',
					category: '',
					mBg: '',
					desc: '',
					logoHeight: '',
					mLogoScale: 1,
					isArea: false,
					isBgOnly: false,
					isContact: false,
					isTouchOpen: false,
					contactName: '',
					contactTel: '',
					contactCompany: '',
					contactAddress: '',
          mInitZoom: '',
					zoom: 10,//3-18
					zoomMobile: 10,//3-18
          zoomRange:[{min:3,max:18,scaleIcon:1,scaleText:1}]
				},
				userInfo: this.$store.state.user.userInfo
			};
		},

		computed: {
			indexUrl() {
				return location.origin + '/index/' + this.userInfo.subjectInfo.id
			}
		},

		created() {

			this.getOptionIndex();
		},

		methods: {

			async getOptionIndex() {
				this.loading = true;
				try {
					let res = await this.api.option.get({name: 'info'});
					this.vForm = Object.assign(this.vForm, configPage.defaultUi, res.data || {});
				} catch (e) {
					console.error(e)
				}
				this.loading = false;
			},

			toIndex() {
				window.open(this.indexUrl, '__blank')
			},
			async doSubmit() {
				this.doSubmitLoading = true;
				try {
					await this.$refs.vForm.validate();
					await this.api.option.set({name: 'info', option: this.vForm});
					this.$message.success('更新成功');
				} catch (e) {
					console.error(e)
				}
				this.doSubmitLoading = false;
			},

			addRange(){
				let preRow = this.vForm.zoomRange[this.vForm.zoomRange.length-1];
				let min = Math.ceil((preRow.max - preRow.min)/2) + preRow.min;
				preRow.max = min;
				this.vForm.zoomRange.push({min,max:18,scaleIcon:1,scaleText:1})
			},

			deleteRange(row,index){
				let preRow = this.vForm.zoomRange[index - 1];
				preRow.max = row.max;
				this.vForm.zoomRange.splice(index,1);
      }
		},


	};
</script>

<style scoped>
  .slider-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
  }

  .slider-box .slider-box-label:last-child {
    margin-right: 140px;
  }

  .range-value-item{
    display: flex;
    align-items: center;
    margin-bottom: 5px;
  }

</style>
